import * as z from "zod";

import { PaymentMethod } from "@modules/checkout/enums/payment-method";

import { PaymentMethodSchema } from "./payment-method.schema";
import { CardDtoSchema } from "./card-dto.schema";

const METHOD_LABEL = {
  [PaymentMethod.PIX]: "PIX",
  [PaymentMethod.Boleto]: "Boleto",
} as const;

export const PaymentRequestDtoSchema = z
  .object({
    Method: PaymentMethodSchema,
    CardHolder: z.string().min(6).max(255).optional(),
    CardNumber: z.string().min(10).max(19).optional(),
    ValidThru: z
      .string()
      .regex(/^\d{2}\/\d{2}$/)
      .optional(),
    CVV: z
      .string()
      .regex(/^\d{3}$/)
      .optional(),
    Installments: z
      .preprocess(
        (value) => (value === "" || value == null || value === undefined ? undefined : value),
        z.coerce.number().int().min(1),
      )
      .optional(),
    ExternalAuthentication: z
      .object({
        Cavv: z.string(),
        Xid: z.string().nullable().optional(),
        Eci: z.string(),
        Version: z.string(),
        ReferenceID: z.string().nullable().optional(),
      })
      .optional(),
    ExternalAuthenticationFailure: z.record(z.string(), z.unknown()).optional(),
  })
  .superRefine((payload, ctx) => {
    if (payload.Method === PaymentMethod.Boleto || payload.Method === PaymentMethod.PIX) {
      if (typeof payload.Installments === "number") {
        ctx.addIssue({
          path: ["Installments"],
          message: `Não é permitido parcelamento para o método ${METHOD_LABEL[payload.Method]}.`,
          code: "custom",
        });
      }
    }

    if (payload.Method === PaymentMethod.CreditCard) {
      if (!payload.Installments) {
        ctx.addIssue({
          path: ["Installments"],
          message: "Quantidade de parcelas é obrigatória",
          code: "custom",
        });
      }

      if (!payload.CardHolder || !payload.CardNumber || !payload.ValidThru) {
        ctx.addIssue({
          path: ["Card"],
          message: "Dados do cartão são obrigatórios",
          code: "custom",
        });
      }
    }
  })
  .transform((payload) => {
    const isCreditCard = payload.Method === PaymentMethod.CreditCard;

    return {
      Method: payload.Method,
      Installments: isCreditCard ? payload.Installments : null,
      Card: isCreditCard ? CardDtoSchema.parse(payload) : null,
      ExternalAuthentication: payload.ExternalAuthentication ?? null,
      ExternalAuthenticationFailure: payload.ExternalAuthenticationFailure ?? null,
    };
  });
